import segmentLoader from './segment-loader';

export default {
  segmentLoader,
};
